var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-component -showcase"},_vm._l((_vm.showcaseData.items),function(itemData){return _c('ShowcaseItem',{key:itemData.id,attrs:{"item-data":itemData}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }